import Icon from 'molecules/Icon';
import Section from 'molecules/Section';
import { splitSectionProps } from 'molecules/Section/config';

import Reveal from 'components/Animations/Reveal';

import { hasArrayValues } from 'utils/array/arrays';

import type { EventOverviewProps } from 'components/EventOverview/config';
import type { FC } from 'react';

const EventOverview: FC<EventOverviewProps> = props => {
  const { sectionProps, rest } = splitSectionProps(props);
  const { leftHeading, leftBody, rightHeading, items } = rest;

  return (
    <Section {...sectionProps} noDarkMode>
      <div className="grid grid-cols-1 gap-12 lg:grid-cols-2 lg:gap-16">
        <Reveal className="flex flex-col gap-6">
          {leftHeading && (
            <h2 className="font-spaceGrotesk text-display-xs font-semibold text-gray-900">{leftHeading}</h2>
          )}
          {leftBody && (
            <div
              className="flex flex-col gap-4 text-md leading-relaxed text-gray-700 sm:text-lg [&_p]:text-gray-700"
              dangerouslySetInnerHTML={{ __html: leftBody }}
            />
          )}
        </Reveal>

        <Reveal delay={0.1} className="flex flex-col gap-6">
          {rightHeading && (
            <h2 className="font-spaceGrotesk text-display-xs font-semibold text-gray-900">{rightHeading}</h2>
          )}
          {hasArrayValues(items) && (
            <ul className="flex flex-col gap-5">
              {items.map(item => (
                <li key={item.text} className="flex items-start gap-3">
                  <div className="mt-1 flex size-6 shrink-0 text-primary-1100">
                    <Icon icon="circle-check" size={24} className="size-full rounded-full stroke-2" />
                  </div>
                  <span className="text-md leading-relaxed text-gray-700 sm:text-lg">{item.text}</span>
                </li>
              ))}
            </ul>
          )}
        </Reveal>
      </div>
    </Section>
  );
};

export default EventOverview;
